export default __webpack_public_path__ + "static/media/CRM-4.489329b3.png";